import {Button, Typography, Input} from 'antd';
import React from 'react';

import {formatTime, maskEmail} from '../../pages/forgotPassword/Utils/common';

const {Title, Text, Link} = Typography;

interface OtpVerificationViewProps {
  email: string;
  otp: string;
  otpError: boolean;
  timer: number;
  verifyingOTPAction: boolean;
  resendingOTPAction: boolean;
  onOtpChange: (value: string) => void;
  onVerify: () => void;
  onResendOtp: () => void;
  onChangeEmail: () => void;
  inputRef: React.Ref<any>;
  buttonLabel: string;
}

const OtpVerificationView: React.FC<OtpVerificationViewProps> = ({
  email,
  otp,
  otpError,
  timer,
  verifyingOTPAction,
  resendingOTPAction,
  onOtpChange,
  onVerify,
  onResendOtp,
  onChangeEmail,
  inputRef,
  buttonLabel
}) => {
  return (
    <div className="otp-container">
      <Title level={3}>Please check your email</Title>
      <Text>
        We have sent a 6-digit code to <strong>{maskEmail(email)}</strong>
      </Text>

      <div className="otp-inputs">
        <Input.OTP
          key={otp === '' ? 'cleared' : 'normal'}
          ref={inputRef}
          length={6}
          value={otp}
          formatter={(value) => value.replace(/\D/g, '').slice(0, 6)}
          onChange={(value) => {
            onOtpChange(value);
          }}
          status={otpError ? 'error' : undefined}
          variant="outlined"
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            gap: '8px'
          }}
        />
      </div>

      <div className="otp-footer">
        <div style={{paddingLeft: 8}}>
          {timer === 0 && (
            <Link
              onClick={onResendOtp}
              style={{color: 'rgb(21, 154, 132)', textDecoration: 'underline'}}
            >
              {resendingOTPAction ? 'Resending OTP' : 'Resend OTP'}
            </Link>
          )}
        </div>
        <div style={{paddingRight: 10}}>
          {timer === 0 ? '' : <Text>{formatTime(timer)}</Text>}
        </div>
      </div>

      <Button
        type="primary"
        block
        onClick={onVerify}
        disabled={otp.length < 6 || timer === 0 || otpError}
        style={{
          marginTop: 20,
          height: 44,
          backgroundColor: 'rgb(21, 154, 132)',
          fontWeight: 600
        }}
        loading={verifyingOTPAction}
      >
        {verifyingOTPAction ? 'Verifying' : buttonLabel}
      </Button>

      <div className="change-email-link">
        <Link
          onClick={onChangeEmail}
          style={{
            color: '#0d5f4f',
            textDecoration: 'underline',
            fontWeight: 600
          }}
        >
          Change Email Address
        </Link>
      </div>
    </div>
  );
};

export default OtpVerificationView;
